import { Component, OnInit } from '@angular/core';
import {ModalController} from '@ionic/angular';
import {UserService} from '../../user.service';

@Component({
  selector: 'app-account-creation-successful',
  templateUrl: './account-creation-successful.component.html',
  styleUrls: ['./account-creation-successful.component.scss'],
})
export class AccountCreationSuccessfulComponent  implements OnInit {

  get emailVerifyNeeded(): boolean { return this.userService.user.isInternalUser; }

  constructor(private modalController: ModalController, private userService: UserService) { }

  ngOnInit() {}

  dismiss(): void {
    this.modalController.dismiss().then();
  }

}
